import styled from 'styled-components';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { MiddleText } from './styles/common.styles';

export const W3WText = styled(MiddleText)`
  overflow-x: hidden;
  width: 110px;
  text-overflow: ellipsis;
  @media (max-width: ${BP_LAPTOP}px) {
    ${({ isHistoricLocation }) =>
      isHistoricLocation ? '110px' : 'width: 100%'}
  }
`;
